import Config from './company-settings.router';
import options from './company-settings.component';

const Component = {
    selector: 'dtCompanySettings',
    options
};

export {
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/company-settings/index.js